<div class="impersonation-dropdown w-full">
  <!-- Search input -->
  <div class="p-3 border-b border-gray-200 dark:border-gray-700">
    <input
      #searchInput
      type="text"
      [(ngModel)]="searchText"
      (ngModelChange)="onSearchChange($event)"
      (keydown)="onKeydown($event)"
      placeholder="Search by name, email or establishment..."
      class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-primary-500 focus:border-transparent"
    />
  </div>

  <!-- Results container -->
  <div class="max-h-80 overflow-y-auto">
    <!-- Loading skeleton -->
    @if (isLoading()) {
      @for (i of [1, 2, 3, 4, 5]; track i) {
        <div class="p-3 border-b border-gray-100 dark:border-gray-700">
          <div class="h-4 bg-gray-200 dark:bg-gray-700 rounded w-3/4 mb-2 animate-pulse"></div>
          <div class="h-3 bg-gray-100 dark:bg-gray-600 rounded w-1/2 mb-1 animate-pulse"></div>
          <div class="h-2.5 bg-gray-100 dark:bg-gray-600 rounded w-2/5 animate-pulse"></div>
        </div>
      }
    }

    <!-- Results list -->
    @else if (users().length > 0) {
      @for (user of users(); track user.id; let i = $index) {
        <div
          class="user-item p-3 border-b border-gray-100 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer transition-colors duration-150"
          [class.highlighted]="highlightedIndex() === i"
          [class.bg-primary-50]="highlightedIndex() === i"
          [class.dark:bg-primary-900]="highlightedIndex() === i"
          (click)="onUserClick(user, i)"
          (keydown.enter)="onUserClick(user, i)"
          (keydown.space)="onUserClick(user, i)"
          tabindex="0"
          role="button"
        >
          <div
            class="font-medium text-gray-900 dark:text-gray-100"
            [innerHTML]="highlightMatch(formatUserName(user), searchText)"
          ></div>
          <div
            class="text-sm text-gray-500 dark:text-gray-400"
            [innerHTML]="highlightMatch(user.email ?? '', searchText)"
          ></div>
          @if (user.defaultEstablishmentName) {
            <div
              class="text-xs text-gray-400 dark:text-gray-500 mt-1"
              [innerHTML]="highlightMatch(user.defaultEstablishmentName, searchText)"
            ></div>
          }
        </div>
      }
    }

    <!-- Empty state -->
    @else if (showEmptyState()) {
      <div class="p-6 text-center text-gray-500 dark:text-gray-400">No users found</div>
    }

    <!-- Initial state hint -->
    @else if (!isLoading() && searchText.length < 3) {
      <div class="p-6 text-center text-gray-400 dark:text-gray-500 text-sm">
        Type at least 3 characters to search
      </div>
    }
  </div>
</div>
